export enum SnappingStatus {
  snapOrFatal = 0,
  snapIfAvailable = 1,
  snapSucceeded = 2,
  snapFatal = 3,
  snapFailed = 4
}
